const dealerFilter = (dealers, searchTerm) => {
  if (!searchTerm.trim()) return dealers

  const searchTerms = searchTerm.toLowerCase().split(/\s+/)

  const matchesFilter = (dealer, parameter, term) => {
    return dealer.attributes[parameter]?.toString().toLowerCase().includes(term)
  }

  return dealers.filter((dealer) => {
    return searchTerms.every((term) => {
      return (
        matchesFilter(dealer, 'name', term) ||
        matchesFilter(dealer, 'dealer-name', term) ||
        matchesFilter(dealer, 'city-state', term) ||
        matchesFilter(dealer, 'city', term) ||
        matchesFilter(dealer, 'state', term) ||
        matchesFilter(dealer, 'zip', term) ||
        matchesFilter(dealer, 'address', term)
      )
    })
  })
}

export default dealerFilter
